export function useVariants(article: Ref<any | null>) {
    const variants = computed(() => {
        const a = article.value;
        if (!a) return [];

        const list = [...(a.variants?.collection ?? []), a];
        return list.sort((x: any, y: any) => {
            const xn = x?.name ?? '';
            const yn = y?.name ?? '';
            if (xn > yn) return 1;
            if (xn < yn) return -1;

            const xn2 = x?.name2 ?? '';
            const yn2 = y?.name2 ?? '';
            if (xn2 > yn2) return 1;
            if (xn2 < yn2) return -1;
            return 0;
        });
    });

    const variantItems = computed(() => variants.value.map((v: any) => ({
        label: [v.name, v.name2].filter(Boolean).join(' '),
        value: String(v._id),
    })));

    function findVariantById(id: string) {
        return variants.value.find((v: any) => String(v._id) === String(id)) ?? null;
    }

    return {variants, variantItems, findVariantById};
}
